import { LoaderFunction, redirect } from "react-router-dom";
import { routes } from "~/lib/constants";
import { authActions } from "~/redux/slice/auth";
import store from "~/redux/store";

export const LogoutLoader: LoaderFunction = async ({ request }) => {
  const url = new URL(request.url);
  const redirectTo = url.searchParams.get("redirectTo") || "/";

  store.dispatch(authActions.clearTokens());

  return redirect(routes.login() + `?redirectTo=${redirectTo}`);
};

export default function Logout() {
  return <div>logout</div>;
}
